import React, { useEffect, useState } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Flex, Modal, Stack, Text, TextInput } from '@mantine/core';
import { t } from 'i18next';
import { IFacilitySelection } from '../../../global/entities/healthcareProfessional/HealthcareProfessional.ts';
import { modals } from '@mantine/modals';

interface IAffiliatedFacilityModalProps {
    opened: boolean;
    close: () => void;
    facility?: IFacilitySelection;
    handleRemoveFacility: (facilityId: string) => void;
    handleAddFacility: (facility: IFacilitySelection) => void;
}

const AffiliatedFacilityModal: React.FC<IAffiliatedFacilityModalProps> = inject()(
    observer(({ opened, close, facility, handleRemoveFacility, handleAddFacility }) => {
        const [assistant, setAssistant] = useState(facility?.assistant || '');
        const [assistantEmail, setAssistantEmail] = useState(facility?.assistantEmail || '');

        useEffect(() => {
            setAssistant(facility?.assistant || '');
            setAssistantEmail(facility?.assistantEmail || '');
        }, [facility]);

        const isValidEmail = (email: string): boolean => {
            if (!email) return true;
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            setMailError(!emailRegex.test(email));
            return emailRegex.test(email);
        };
        const [mailError, setMailError] = useState(false);
        const openModalDelete = () => {
            if (facility)
                {return modals.openConfirmModal({
                    title: t('modal.deleteItemModal.title'),
                    children: (
                        <Stack gap={'sm'}>
                            <Text>{t('modal.deleteItemModal.question')}</Text>
                            <Text fw={'bold'}> {t('modal.deleteItemModal.details')}</Text>
                        </Stack>
                    ),
                    labels: { confirm: t('button.delete'), cancel: t('button.cancel') },
                    confirmProps: { color: 'red' },
                    cancelProps: { variant: 'outline', color: 'gray' },
                    onCancel: () => console.log('Suppression annulée'),
                    onConfirm: () => {
                        handleRemoveFacility(facility.healthcareFacilityID.toString());
                        onClose();
                    },
                    size: 'lg',
                    radius: 'xs',
                });}
        };

        const onClose = () => {
            setAssistant('');
            setAssistantEmail('');
            close();
        };

        return (
            <Modal withCloseButton={false} opened={opened} onClose={close} size="sm" radius="xs">
                <Stack>
                    <TextInput
                        disabled
                        readOnly
                        label={t('formHcf.healthFacilityName')}
                        value={facility?.facilityName}
                    />

                    <TextInput
                        label={t('formHcf.assistantName')}
                        placeholder={t('formHcf.enterAssistantName')}
                        value={assistant}
                        onChange={(e) => setAssistant(e.currentTarget.value)}
                    />

                    <TextInput
                        label={t('formHcf.assistantEmail')}
                        placeholder={t('formHcf.enterAssistantEmail')}
                        value={assistantEmail}
                        onChange={(e) => setAssistantEmail(e.currentTarget.value)}
                        error={mailError && t('formError.mailIsInvalid')}
                    />

                    <Flex gap={'md'} mt="md">
                        <Button variant={'outline'} color="red" onClick={openModalDelete}>
                            {t('button.delete')}
                        </Button>
                        <Button ml={'auto'} variant="default" onClick={close}>
                            {t('button.cancel')}
                        </Button>
                        <Button
                            onClick={() => {
                                if (isValidEmail(assistantEmail) && facility) {
                                    handleAddFacility({
                                        facilityName: facility.facilityName,
                                        healthcareFacilityID: facility.healthcareFacilityID,
                                        assistant,
                                        assistantEmail,
                                    });
                                    onClose();
                                } else 
                                    setMailError(true);
                                
                            }}
                        >
                            {t('button.ok')}
                        </Button>
                    </Flex>
                </Stack>
            </Modal>
        );
    }),
);

export default AffiliatedFacilityModal;
